import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { HelpDataProvider } from './lib/data'

import './styles.css'

const preload = window.__HELP_PRELOAD__
const root = document.getElementById('root')!

const tree = (
  <StrictMode>
    <HelpDataProvider preload={preload}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelpDataProvider>
  </StrictMode>
)

// Prerendered pages ship markup + preload; everything else boots as a SPA.
if (preload && root.hasChildNodes()) {
  hydrateRoot(root, tree)
} else {
  createRoot(root).render(tree)
}
